import ZNSConfiguration from "./ZNSConfiguration";

export default ZNSConfiguration;
